// Manual payment modes a PM can record; anything else (charges, credits, unknown) has no account
const MANUAL_PAYMENT_MODES = {
  CASH: "Cash",
  Check: "Check",
  "Certified Check": "Certified Check",
  "Money Order": "Money Order",
  "Credit Card": "Credit Card",
  Other: "Other",
};

// One-time ACH payments are stored as ACH and autopays as BANK; both are bank payments (was mislabeled Cash)
export const accountLabel = (row) => {
  if (row?.payment_mode === "BANK" || row?.payment_mode === "ACH" || row?.status === "SCHEDULED") {
    const name = row?.nick_name || row?.bank_name || "";
    const digits = row?.account_number || "";
    // Payment with no linked bank details shows BANK instead of a bare "..."
    return name || digits ? `${name}...${digits}` : "BANK";
  }
  return MANUAL_PAYMENT_MODES[row?.payment_mode] || "—";
};
